@if (isEmailSent) {
  <cpd-dialog-container2
    [title]="sentTitle"
    [message]="sentMessage"
    [icon]="'send'"
  >
    <div dialog-body>
      <section class="actions">
        <cpd-flat-button
          mat-dialog-close
          type="button"
          color="primary"
          size="large"
          text="Close"
        >
        </cpd-flat-button>
      </section>
    </div>
  </cpd-dialog-container2>
} @else {
  @if (
    {
      returnLink: returnLink$ | async,
      isSpaceForce: isSpaceForce$ | async,
      isAirForce: isAirForce$ | async
    };
    as data
  ) {
    <cpd-dialog-container2
      [title]="title"
      [message]="introMessage"
      [icon]="'send'"
    >
      <div [ngClass]="{ 'disabled-form': !data.returnLink }" dialog-body>
        <div
          [matTooltipPosition]="'above'"
          [matTooltipClass]="'green'"
          [matTooltipDisabled]="!!data.returnLink"
          [matTooltip]="
            data.isAirForce || data.isSpaceForce
              ? tooltipMsgForAirforce
              : tooltipMsg
          "
          class="return-link"
        >
          <div class="return-link__form-field">
            <fa-icon class="icon" [icon]="['far', 'link']"></fa-icon>
            <input
              aria-label="Your return link"
              readonly type="text" [value]="data.returnLink" />
          </div>
          <cpd-copy-button
            [hasBorder]="true"
            [returnLink]="data.returnLink"
          ></cpd-copy-button>
        </div>

        <form
          [formGroup]="formGroup"
          (ngSubmit)="onSubmit()"
        >
          <mat-form-field
            [matTooltipPosition]="'above'"
            [matTooltipClass]="'green'"
            [matTooltipDisabled]="!!data.returnLink"
            [matTooltip]="
              data.isAirForce || data.isSpaceForce
                ? tooltipMsgForAirforce
                : tooltipMsg
            "
            appearance="outline"
            class="email-input"
          >
            <fa-icon
              matPrefix
              [icon]="['far', 'envelope']"
              class="text-blue mr-1 ml-3"
            >
            </fa-icon>
            <input
              aria-label="Email address"
              type="email"
              formControlName="email"
              autocomplete="email"
              placeholder="your@email.com"
              matInput
            />
            <mat-error>
              {{
                formGroup.controls.email.errors?.required
                  ? 'Please enter an email address'
                  : 'Please enter a valid email address'
              }}
            </mat-error>
          </mat-form-field>
          <div class="actions">
            <cpd-flat-button
              type="submit"
              color="primary"
              size="large"
              text="Send"
              [ngClass]="{ disabled: !formGroup.valid }"
              [disabled]="!formGroup.valid"
            >
            </cpd-flat-button>
          </div>
        </form>
      </div>
    </cpd-dialog-container2>
  }
}
